import React, { useMemo } from 'react';

import { isWebpSupported } from '@interlayer/js/app/utils/common.util';

import { TImageSupportedWebpProps } from './types';

const getImage = (webpImage: string, image: string): string => {
    if (!webpImage && !image) {
        return '';
    }

    const isWebp = webpImage
        ?.split('.')
        ?.pop()
        ?.toLowerCase() === 'webp';

    const isSupported = isWebp ? isWebpSupported() : true;

    return isSupported && webpImage ? webpImage : image;
};

export const ImageSupportedWebp: React.FC<TImageSupportedWebpProps> = ({
    webpImage = '',
    image = '',
    imageRef,
    onClick,
    alt = 'image',
    className,
    id
}) => {
    const imageSrc = useMemo(() => getImage(webpImage, image), [image, webpImage]);

    if (!imageSrc) {
        return null;
    }

    return (
        <img
            data-testid="ImageSupportedWebp_image"
            {...id && { id }}
            alt={alt}
            ref={imageRef}
            className={className}
            src={imageSrc}
            {...onClick && { onClick }}
        />
    );
};
